import { makeStyles } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React from 'react';
import { translate } from '../../../../../common/intl';
import { GeneralSettings } from '../../../../../state/ducks/company/types';
import { Colors } from '../../../../layout/theme-next';
import SettingsPanel from '../../components/SettingsPanel';
import SettingsPanelSection from '../../components/SettingsPanelSection';
import SwitchControl from '../../components/SwitchControl';
import { SettingsPanelProps } from '../../types';

const useStyles = makeStyles(theme => ({
  title: {
    color: Colors.textBlack,
    fontSize: 14,
    fontWeight: 600,
    marginBottom: theme.spacing(0.25),
  },
  description: {
    color: Colors.textGray,
    fontSize: 12,
    lineHeight: 1.5,
  },
}));

const PreviousRevisionDownloads: React.FC<SettingsPanelProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { getFieldProps, values } = useFormikContext<GeneralSettings>();
  const classes = useStyles();

  return (
    <SettingsPanel
      {...props}
      title={translate('administration.general.settings.previous.revision.downloads')}
    >
      <SettingsPanelSection>
        <SwitchControl
          {...getFieldProps('restrictPreviousRevisionAttachmentDownloads')}
          checked={Boolean(values.restrictPreviousRevisionAttachmentDownloads)}
          label={(
            <div>
              <div className={classes.title}>
                {translate('administration.general.settings.previous.revision.downloads.restrict')}
              </div>
              <div className={classes.description}>
                {translate('administration.general.settings.previous.revision.downloads.info')}
              </div>
            </div>
          )}
        />
      </SettingsPanelSection>
    </SettingsPanel>
  );
};

export default PreviousRevisionDownloads;
